module.exports = __webpack_public_path__ + "img/community-active.847f8966.svg";